/* Swipe pages: countdown, gallery, menu drawer, sticky add-to-cart, in-page scroll. */
(function () {
  var smooth = function () { return document.visibilityState === 'visible' ? 'smooth' : 'auto'; };

  // Countdown to local midnight (sale timer in the announcement bar)
  function tick() {
    var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var parts = { h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
    document.querySelectorAll('[data-cd]').forEach(function (el) {
      ['h', 'm', 's'].forEach(function (k) {
        var n = el.querySelector('[data-cd-' + k + ']');
        if (n) n.textContent = String(parts[k]).padStart(2, '0');
      });
    });
  }

  function gallery(root) {
    var track = root.querySelector('.pp-gal__track');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('.pp-gal__thumbs button');
    if (!track || !slides.length) return;
    var current = 0;
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth() });
      mark(i);
    }
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - 8, behavior: smooth() });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    var prev = root.querySelector('.pp-gal__arrow--prev'), next = root.querySelector('.pp-gal__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
      });
    }, { passive: true });
  }

  function drawer() {
    var d = document.querySelector('[data-drawer]');
    if (!d) return;
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { d.setAttribute('open', ''); b.setAttribute('aria-expanded', 'true'); });
    });
    d.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') d.removeAttribute('open'); });
  }

  function sticky() {
    var bar = document.querySelector('[data-sticky-atc]'), target = document.querySelector('[data-main-atc]');
    if (!bar || !target) return;
    var update = function () {
      var r = target.getBoundingClientRect();
      var on = r.bottom < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    var btn = bar.querySelector('[data-sticky-submit]');
    if (btn) btn.addEventListener('click', function () {
      var f = document.querySelector('[data-main-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else if (f.dispatchEvent(new Event('submit', { cancelable: true }))) f.submit(); }
    });
  }

  function lsSticky() {
    var bar = document.querySelector('[data-ls-sticky]');
    if (!bar) return;
    var start = document.querySelector('.ls-hero .sw-btn') || document.querySelector('.lf__cta') || document.querySelector('.ls-hero');
    var offer = document.getElementById('offer');
    var update = function () {
      var past = start ? start.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var o = offer ? offer.getBoundingClientRect() : null;
      var offerOn = o ? (o.top < window.innerHeight && o.bottom > 0) : false;
      var on = past && !offerOn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Free gift: skip it if it's already in the cart, so a second click never charges for it
  function giftGuard() {
    var form = document.querySelector('[data-main-form]');
    var gift = form && form.querySelector('[data-gift-variant]');
    if (!form || !gift || form.dataset.giftGuard) return;
    form.dataset.giftGuard = '1';
    form.addEventListener('submit', function (e) {
      if (form.dataset.checked) return;
      e.preventDefault();
      var go = function () { form.dataset.checked = '1'; form.submit(); };
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var id = Number(gift.getAttribute('data-gift-variant'));
        if (c.items.some(function (i) { return i.variant_id === id; })) {
          form.querySelectorAll('[data-gift-input]').forEach(function (el) { el.disabled = true; });
        }
        go();
      }).catch(go);
    });
  }

  function anchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1), el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: smooth(), block: 'start' });
      });
    });
  }

  function cartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (c.item_count > 0) { el.textContent = c.item_count; el.hidden = false; }
    }).catch(function () {});
  }

  function init() {
    if (document.querySelector('[data-cd]')) { tick(); setInterval(tick, 1000); }
    document.querySelectorAll('[data-gallery]').forEach(gallery);
    drawer(); sticky(); lsSticky(); giftGuard(); anchors(); cartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Speed (2026-10-20): SVG <image> tags never lazy-load on their own, so the science + jaw-map photos (~200 KB) used to
   download on page open. They carry data-lazy-href and get their href when their SVG is ~800px from the screen. */
(function(){
  var imgs=[].slice.call(document.querySelectorAll('image[data-lazy-href]'));
  if(!imgs.length) return;
  function ld(el){ var u=el.getAttribute('data-lazy-href'); if(!u) return; el.setAttribute('href',u); el.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href',u); el.removeAttribute('data-lazy-href'); }
  if(!('IntersectionObserver' in window)){ imgs.forEach(ld); return; }
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ [].forEach.call(e.target.querySelectorAll('image[data-lazy-href]'),ld); io.unobserve(e.target); } }); },{rootMargin:'800px 0px'});
  imgs.forEach(function(el){ io.observe(el.ownerSVGElement||el); });
})();
